// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28sUP","right":"styles_right__1BdEu"};